import { ControlValueAccessor, NG_VALUE_ACCESSOR, AbstractControl } from '@angular/forms';
import { BsDatepickerConfig, BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { Component, OnInit, forwardRef, Input, ViewChild } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { takeUntil } from 'rxjs/operators';

import { getDatepickerConfig } from '../../functions';
import { UnsubscriberClass } from '../../classes/unsubscriber.class';
import { InputRestrictionDirective } from '../../directives/input-restriction/input-restriction.directive';
import { FormDndValidateDirective } from '../../directives/forms/form-dnd-validate.directive';



@Component({
	selector: 'form-datepicker',
	templateUrl: './datepicker.component.html',
	providers: [{
		provide: NG_VALUE_ACCESSOR,
		useExisting: forwardRef(() => DatepickerComponent),
		multi: true
	}],
	imports: [FormDndValidateDirective, BsDatepickerModule, InputRestrictionDirective, TranslateModule]
})
export class DatepickerComponent extends UnsubscriberClass implements OnInit, ControlValueAccessor {
	// DOC:
	// https://alligator.io/angular/custom-form-control/
	// https://blog.thoughtram.io/angular/2016/07/27/custom-form-controls-in-angular-2.html

	@Input() control: AbstractControl;
	@Input() inputClass = '';
	@Input() groupClass = '';
	@Input() controlId: string;
	@Input() isDisabled = false;
	@Input() daysDisabled: number[];
	@Input() placement: 'top' | 'bottom' | 'left' | 'right' = 'bottom';
	@Input() isDateTime = false;
	@Input() forcePropagation = false;
	@Input() disabledDates: Date[];

	@Input() minDate: Date;
	@Input() maxDate: Date;

	@ViewChild('input') input;

	innerValue: Date;
	value: Date;

	bsConfig: BsDatepickerConfig = getDatepickerConfig();
	private propagateChange = (_: any) => _;

	ngOnInit() {
		this.innerValue = this.control.value;

		if (this.isDateTime) {
			this.bsConfig.dateInputFormat = 'DD/MM/YYYY | HH:mm';
		}

		if (this.disabledDates) {
			this.bsConfig.datesDisabled = this.disabledDates;
		}

		// FIXME: Find a way to avoid double check
		// Currently there is a bug on setting the date Account creation's step 2 for the legal representative
		this.control.valueChanges
			.pipe(takeUntil(this.destroySubscriptions$))
			.subscribe(_ => {
				this.innerValue = this.control.value || null;
			});
	}

	writeValue(value: Date) {
		if (!!value || this.forcePropagation) {
			this.value = value;
			this.propagateChange(this.value);
		}
	}

	registerOnChange(fn: (date: Date) => void) {
		this.propagateChange = fn;
	}

	registerOnTouched(_fn: () => void) {
		//
	}

	setDisabledState(isDisabled: boolean): void {
		this.isDisabled = isDisabled;

		//Until the datePicker library is fixed, this will set/remove the readonly attribute instead of setting its value to true/false
		setTimeout(() => isDisabled ? this.input?.nativeElement.setAttribute('readonly', '') : this.input?.nativeElement.removeAttribute('readonly'), 500);
	}
}
